/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from './uiold';
import { sizes, themeColors } from './uiold/Constants';
import LoadingIndicator from './uiold/LoadingIndicator';

import SideNav from './VendorPortal/SideNav';
import Content from './VendorPortal/Content';

import AppAlert, { showError } from './App/AppAlert';

import DataStore from '../support/DataStore';
import enhancedSessionStorage from '../support/enhancedSessionStorage';
import getErrorMessage from '../support/helpers/getErrorMessage';
import { fetchData } from '../support/Fetch';
import isObject from '../support/shared/isObject';

import { AppDialog } from './App/AppDialog';
import { getInitialParams } from '../support/InitialParams';
import { VendorPortalPage } from '../types/shared/VendorPortalPage';
import { VendorAccount } from '../types/shared/VendorAccount';

type Props = {
  marketName: string;
  marketAccountID: string;
};

type State = {
  displayMyInfo: boolean;
  displayHomepage: boolean;
  displayLoginModal: boolean;
  email: string;
  billingLink: string | undefined;
  isMounted: boolean;
  isLoading: boolean;
  showRegistrationModal: boolean;
  selectedPage: VendorPortalPage | null | undefined;
};

const dataStore = DataStore.getInstance('app');

const storageKeyOld = 'vendor-account';
const storageKey = 'vendor-auth-token';

export default class VendorPortalHome extends Component<Props, State> {
  state: State = {
    displayMyInfo: false,
    displayHomepage: false,
    displayLoginModal: false,
    email: toString(getInitialParams().email) ?? '',
    billingLink: undefined,
    isMounted: true,
    isLoading: true,
    showRegistrationModal: false,
    selectedPage: null,
  };

  _subscription: Subscription | undefined;

  componentDidMount() {
    this._subscription = dataStore.onChange('vendorAccount', (newAccount) => {
      const authToken = newAccount?.token;
      if (authToken) {
        enhancedSessionStorage.set(storageKey, authToken);
      } else {
        enhancedSessionStorage.delete(storageKey);
      }
      this.forceUpdate();
    });
    // Legacy support for storageKeyOld which stored the full vendorAccount
    const vendorAccountMaybe = enhancedSessionStorage.get(storageKeyOld);
    enhancedSessionStorage.delete(storageKeyOld);
    const authToken = isObject(vendorAccountMaybe)
      ? toString(vendorAccountMaybe.token)
      : toString(enhancedSessionStorage.get(storageKey));
    if (!authToken) {
      this.setState({ isLoading: false, displayHomepage: true });
      return;
    }
    // TODO: Remove this line and the legacy stuff above.
    enhancedSessionStorage.set(storageKey, authToken);
    let headers = {
      'X-Vendor-Auth-Token': authToken,
    };
    fetchData('/api/vendor-auth/refresh', { headers }, (error, data) => {
      if (!this.state.isMounted) {
        return;
      }
      let errorMessage = getErrorMessage(error, data);
      if (errorMessage) {
        // Note: We're not resetting isLoading here
        showError(errorMessage);
      } else if (data.success) {
        const { account, token, billingLink } = data;
        this._onLoginSuccess({ ...account, token }, billingLink);
      }
    });
  }

  componentWillUnmount() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndicator />;
    }
    let {
      displayMyInfo,
      displayLoginModal,
      email,
      billingLink,
      showRegistrationModal,
      displayHomepage,
      selectedPage,
    } = this.state;
    let { marketName, marketAccountID } = this.props;
    let vendorAccount = dataStore.get('vendorAccount');

    return (
      <View style={styles.root}>
        <View style={styles.sideNav}>
          <View style={styles.heading}>
            <Text type="heading" style={styles.headingText}>
              {marketName}
            </Text>
          </View>
          <SideNav
            displayMyInfo={displayMyInfo}
            marketName={marketName}
            marketAccountID={marketAccountID}
            vendorAccount={vendorAccount}
            displayLoginModal={displayLoginModal}
            toggleLoginModal={this._toggleLoginModal}
            onLoginSuccess={this._onLoginSuccess}
            toggleMyInfo={this._toggleMyInfo}
            showRegistrationModal={showRegistrationModal}
            toggleRegistrationModal={this._toggleRegistrationModal}
            toggleHomePage={this._toggleHomePage}
            changeSelectedVendorPortalPage={this._changeSelectedPage}
            selectedVendorPortalPage={selectedPage}
            displayHomepage={displayHomepage}
            email={email}
            billingLink={billingLink}
            setEmail={this._setEmail}
          />
        </View>
        <View style={styles.pageContent}>
          <Content
            selectedVendorPortalPage={selectedPage}
            displayHomepage={displayHomepage}
            vendorAccount={vendorAccount}
            marketAccountID={marketAccountID}
            marketName={marketName}
            toggleLoginModal={this._toggleLoginModal}
            toggleMyInfo={this._toggleMyInfo}
            displayMyInfo={displayMyInfo}
          />
        </View>
        <AppDialog />
        <AppAlert />
      </View>
    );
  }

  _onLoginSuccess = (
    vendorAccount: VendorAccount,
    billingLink: string | undefined,
  ) => {
    dataStore.set('vendorAccount', vendorAccount);
    this.setState({
      isLoading: false,
      billingLink: toString(billingLink),
    });
    this._toggleMyInfo(true);
  };

  _setEmail = (value: string) => {
    this.setState({ email: value });
  };

  _toggleMyInfo = (value: boolean) => {
    if (value === true) {
      this.setState({
        displayMyInfo: value,
        displayHomepage: false,
        selectedPage: null,
      });
    } else {
      this.setState({ displayMyInfo: value });
    }
  };

  _toggleHomePage = (value: boolean) => {
    if (value === true) {
      this.setState({
        displayMyInfo: false,
        displayHomepage: value,
        selectedPage: null,
      });
    } else {
      this.setState({ displayHomepage: value });
    }
  };

  _toggleLoginModal = (value: boolean) => {
    this.setState({ displayLoginModal: value });
  };

  _toggleRegistrationModal = (value: boolean) => {
    this.setState({ showRegistrationModal: value });
  };

  _changeSelectedPage = (selectedPage: VendorPortalPage | null) => {
    this.setState({ selectedPage });
    if (selectedPage != null) {
      this.setState({
        displayMyInfo: false,
        displayHomepage: false,
        selectedPage,
      });
    } else {
      this.setState({ selectedPage });
    }
  };
}

function toString(value: unknown) {
  return typeof value === 'string' ? value : undefined;
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: themeColors.white,
    flexDirection: 'row',
  },
  heading: {
    borderBottomWidth: 1,
    borderColor: themeColors.borderGrey,
    paddingVertical: 24,
  },
  headingText: {
    color: themeColors.black,
    fontSize: 20,
    fontWeight: '500',
    paddingHorizontal: 26,
  },
  sideNav: {
    flexDirection: 'column',
    width: sizes.resourcesNavWidth,
    zIndex: 1,
    borderRightWidth: 1,
    borderColor: themeColors.borderGrey,
    overflow: 'scroll',
  },
  pageContent: {
    flex: 1,
    paddingTop: 36,
  },
});
